import { useQuery } from "@tanstack/react-query";

import type { IWebsiteAnalysisTrafficRequestParams } from "app/pages/website-analysis/TrafficAndEngagement/types";
import WebsiteAnalysisApiService from "app/services/WebsiteAnalysis/WebsitAnalysisApiService";

interface IDeviceDistributionResponse {
    Data: Array<{
        Domain: string;
        Favicon: string;
        DesktopMobileShareVisits: [number, number];
    }>;
    TotalCount: number;
    KeysDataVerification?: Record<string, boolean>;
}

export const useDeviceDistributionData = (
    params: IWebsiteAnalysisTrafficRequestParams,
    controller: string,
    { enabled = true }: { enabled?: boolean } = {},
) => {
    return useQuery<IDeviceDistributionResponse>({
        queryKey: ["deviceDistribution", params, controller],
        queryFn: () => WebsiteAnalysisApiService.getInstance().getDeviceDistributionData(params, controller),
        enabled,
    });
};
